import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { debounce } from "throttle-debounce";
import getGateways from "./utils/getGateways";
import { getHotelURL } from "../../utils/gatsby-helpers";
import searchBoxAdapter from "./utils/searchBox.adapter";
import { HotelSearchBoxTypeahead } from "./utils/HotelSearchBoxTypeahead";
import { RCL as useTranslation } from "../RCL";

const HotelSearchBox = ({ locale }) => {
	const [typeaheadData, setTypeaheadData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isFocused, setIsFocused] = useState(false);
	const [hotelUrl, setHotelUrl] = useState("");
	const [environment, setEnvironment] = useState();
	const [selectedHotel, setSelectedHotel] = useState();

	const searchLabel = useTranslation({ searchKey: "search" });
	const searchHotelsLabel = useTranslation({ searchKey: "search-hotels" });

	const handleOnFocus = (overrideCondition = false) => {
		if (typeof overrideCondition === "boolean" && overrideCondition) {
			setIsFocused(true);
		}
	};

	const handleOnBlur = (overrideCondition = false) => {
		if (typeof overrideCondition === "boolean" && overrideCondition) {
			setIsFocused(false);
			setTypeaheadData([]);
		}
	};

	const throttleFunc = debounce(500, value => {
		if (value.length > 2) {
			setIsLoading(true);
			getGateways(locale, value)
				.then(data => {
					const response = searchBoxAdapter(data);
					setTypeaheadData(response);
					setIsLoading(false);
				})
				.catch(err => {
					setIsLoading(false);
					console.error(err);
				});
		}
	});

	useEffect(() => {
		setEnvironment(window.document);
	}, []);

	return (
		<>
			{environment && (
				<HotelSearchBoxTypeahead
					id="hotel-search"
					isFocused={isFocused}
					data={typeaheadData}
					loading={isLoading}
					onFocus={handleOnFocus}
					selectedItem={selectedHotel}
					onChange={value => {
						setSelectedHotel(value);
						setHotelUrl(getHotelURL(locale, value.value, value.destination, value.label));
					}}
					onInput={throttleFunc}
					onBlur={handleOnBlur}
					environment={environment}
					searchLabel={searchLabel}
					searchHotelsLabel={searchHotelsLabel}
					hotelUrl={hotelUrl}
				/>
			)}
		</>
	);
};

HotelSearchBox.propTypes = {
	locale: PropTypes.string,
};

HotelSearchBox.defaultProps = {
	locale: undefined,
};

export default HotelSearchBox;
export { HotelSearchBox };
